export class MulticastTask {
    constructor(run) {
        this._run = run;
        this.active = true;
    }
    static create(run) {
        return new MulticastTask(run);
    }
    run(time) {
        if (!this.active)
            return;
        this._run();
    }
    error(time, err) {
        return void 0;
    }
    dispose() {
        this.active = false;
    }
}
//# sourceMappingURL=MulticastTask.js.map